/* @flow */
import React from 'react';
import styled from 'styled-components';
import { getLabel } from '../../utils/i18n';
import FlexBox from '../FlexBox';

const Wrapper = styled.div`
  max-width: 412px;
  padding: 16px;
   background: ${({ theme }) => theme.balanceTooltipBg};
`;

const Title = styled.div`
  font-family: ${({ theme }) => theme.fontIBMRegular};
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  text-decoration-line: underline;
  color: #F0B90B;
`;

const Text = styled.div`
  color: ${({ theme }) => theme.fontColor};
  margin: 8px 0 32px 0;
  font-family: ${({ theme }) => theme.fontIBMRegular};
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
`;

type Props = {
  i18n: Object,
}

const ModeTip = ({ i18n }: Props) => (
  <Wrapper>
    <FlexBox direction="column">
      <Title>
        {getLabel('exchange-common-mode-normalTitle', i18n)}
      </Title>
      <Text>
        {getLabel('exchange-common-mode-normalText', i18n)}
      </Text>
    </FlexBox>

    <FlexBox direction="column">
      <Title>
        {getLabel('exchange-common-mode-borrowTitle', i18n)}
      </Title>
      <Text>
        {getLabel('exchange-common-mode-borrowText', i18n)}
      </Text>
    </FlexBox>

    <FlexBox direction="column">
      <Title>
        {getLabel('exchange-common-mode-repayTitle', i18n)}
      </Title>
      <Text>
        {getLabel('exchange-common-mode-repayText', i18n)}
      </Text>
    </FlexBox>

  </Wrapper>
);

export default ModeTip;
